import {
  authGroupsKeys,
  RequestTypes,
} from '@core/react-query/features/authGroups'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'

export const useDeleteAuthGroup = (
  options?: UseMutationOptions<
    any,
    RequestErrorType,
    RequestTypes['deleteAuthGroup']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...authGroupsKeys.deleteAuthGroup,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: authGroupsKeys._def })
    },
    ...options,
  })
}
